const RU = {
  'equipment.subtitle':
    'Узлы оборудования мойки: запуск программ, статус циклов, телеметрия и прогноз отказов',
  'equipment.col.code': 'Код',
  'equipment.col.name': 'Узел',
  'equipment.col.kind': 'Тип',
  'equipment.col.state': 'Состояние',
  'equipment.col.readings': 'Последние показания',
  'equipment.col.risk': 'Риск отказа (7 сут.)',
  'equipment.col.seen': 'На связи',
  'equipment.kind.portal': 'Портал',
  'equipment.kind.tunnel': 'Тоннель',
  'equipment.kind.self_service': 'Пост самообслуживания',
  'equipment.kind.vacuum': 'Пылесос',
  'equipment.kind.water_treatment': 'Водоподготовка',
  'equipment.kind.compressor': 'Компрессор',
  'equipment.kind.other': 'Другое',
  'equipment.state.running': 'Идёт цикл',
  'equipment.state.idle': 'Свободен',
  'equipment.state.starting': 'Запускается',
  'equipment.state.fault': 'Неисправность',
  'equipment.state.unknown': 'Нет данных',
  'equipment.risk.driver': 'причина: {driver}',
  'equipment.risk.days': 'до порога ≈ {days} сут.',
  'equipment.empty': 'Оборудование не заведено',
  'equipment.emptyReason':
    'Узлы заводит администратор сети: код, тип, адрес контроллера и программы. Без них запуск и телеметрия недоступны.',
  'equipment.add': 'Добавить узел',
  'equipment.recompute': 'Пересчитать прогноз',
  'equipment.recomputed': 'Прогноз пересчитан',
  'equipment.form.title': 'Новый узел',
  'equipment.form.site': 'Объект',
  'equipment.form.code': 'Код',
  'equipment.form.name': 'Название',
  'equipment.form.kind': 'Тип',
  'equipment.form.protocol': 'Подключение',
  'equipment.form.protocol.http': 'Контроллер с HTTP API',
  'equipment.form.protocol.mqtt': 'Только телеметрия через MQTT',
  'equipment.form.protocol.fake': 'Стенд без оборудования',
  'equipment.form.endpoint': 'Адрес контроллера',
  'equipment.form.programs': 'Программы',
  'equipment.form.programsHint': 'По строке: код;название;длительность в секундах',
  'equipment.form.create': 'Завести узел',
  'equipment.form.cancel': 'Отмена',
  'equipment.created': 'Узел заведён',
  'equipment.start': 'Запустить',
  'equipment.started': 'Программа запущена',
  'equipment.cycles': 'Последние циклы',
  'equipment.cycles.empty': 'Циклов ещё не было',
  'equipment.cycle.requested': 'Запрошен',
  'equipment.cycle.running': 'Идёт',
  'equipment.cycle.completed': 'Завершён',
  'equipment.cycle.failed': 'Сбой',
  'equipment.cycle.aborted': 'Прерван',
  'equipment.pickSite': 'Выберите объект вверху, чтобы увидеть его оборудование',
};

const KK: Record<keyof typeof RU, string> = {
  'equipment.subtitle':
    'Жуу жабдығының түйіндері: бағдарламаны іске қосу, цикл күйі, телеметрия және ақау болжамы',
  'equipment.col.code': 'Коды',
  'equipment.col.name': 'Түйін',
  'equipment.col.kind': 'Түрі',
  'equipment.col.state': 'Күйі',
  'equipment.col.readings': 'Соңғы көрсеткіштер',
  'equipment.col.risk': 'Ақау қаупі (7 тәулік)',
  'equipment.col.seen': 'Байланыста',
  'equipment.kind.portal': 'Портал',
  'equipment.kind.tunnel': 'Туннель',
  'equipment.kind.self_service': 'Өзіне-өзі қызмет көрсету посты',
  'equipment.kind.vacuum': 'Шаңсорғыш',
  'equipment.kind.water_treatment': 'Су дайындау',
  'equipment.kind.compressor': 'Компрессор',
  'equipment.kind.other': 'Басқа',
  'equipment.state.running': 'Цикл жүріп жатыр',
  'equipment.state.idle': 'Бос',
  'equipment.state.starting': 'Іске қосылуда',
  'equipment.state.fault': 'Ақау',
  'equipment.state.unknown': 'Дерек жоқ',
  'equipment.risk.driver': 'себебі: {driver}',
  'equipment.risk.days': 'шекке дейін ≈ {days} тәулік',
  'equipment.empty': 'Жабдық енгізілмеген',
  'equipment.emptyReason':
    'Түйіндерді желі әкімшісі енгізеді: код, түрі, контроллер мекенжайы және бағдарламалар.',
  'equipment.add': 'Түйін қосу',
  'equipment.recompute': 'Болжамды қайта есептеу',
  'equipment.recomputed': 'Болжам қайта есептелді',
  'equipment.form.title': 'Жаңа түйін',
  'equipment.form.site': 'Нысан',
  'equipment.form.code': 'Коды',
  'equipment.form.name': 'Атауы',
  'equipment.form.kind': 'Түрі',
  'equipment.form.protocol': 'Қосылым',
  'equipment.form.protocol.http': 'HTTP API бар контроллер',
  'equipment.form.protocol.mqtt': 'MQTT арқылы тек телеметрия',
  'equipment.form.protocol.fake': 'Жабдықсыз стенд',
  'equipment.form.endpoint': 'Контроллер мекенжайы',
  'equipment.form.programs': 'Бағдарламалар',
  'equipment.form.programsHint': 'Әр жолда: код;атауы;секундпен ұзақтығы',
  'equipment.form.create': 'Түйінді енгізу',
  'equipment.form.cancel': 'Болдырмау',
  'equipment.created': 'Түйін енгізілді',
  'equipment.start': 'Іске қосу',
  'equipment.started': 'Бағдарлама іске қосылды',
  'equipment.cycles': 'Соңғы циклдер',
  'equipment.cycles.empty': 'Циклдер әлі болмаған',
  'equipment.cycle.requested': 'Сұралды',
  'equipment.cycle.running': 'Жүріп жатыр',
  'equipment.cycle.completed': 'Аяқталды',
  'equipment.cycle.failed': 'Іркіліс',
  'equipment.cycle.aborted': 'Үзілді',
  'equipment.pickSite': 'Жабдығын көру үшін жоғарыдан нысанды таңдаңыз',
};

export type EquipmentKey = keyof typeof RU;
export type EquipmentTranslate = (key: EquipmentKey, params?: Readonly<Record<string, string | number>>) => string;

export function makeEquipmentT(locale: 'ru' | 'kk'): EquipmentTranslate {
  const dict = locale === 'kk' ? KK : RU;
  return (key, params) => {
    const template = dict[key] ?? RU[key] ?? key;
    if (!params) return template;
    return template.replace(/\{(\w+)\}/g, (m, name: string) =>
      params[name] === undefined ? m : String(params[name]),
    );
  };
}

export const EQUIPMENT_STRINGS = { ru: RU, kk: KK } as const;
